<template>
  <div class="pricing-container">
    <div v-if="mostPurchased" class="deal-container">
      <div class="deal">
        {{ mostPurchasedText }}
      </div>
    </div>

    <h3 class="pricing-title">{{ name }}</h3>
    <p class="pricing-description">{{ description }}</p>

    <div style="text-align: left; margin-top: 1rem; margin-bottom: 1rem;">
      <div class="price-text">
        {{ parsedPrice(unitAmount, currency) }}
      </div>
    </div>
    <div v-if="subtitle !== ''" class="save-pricing-text">{{ subtitle }}</div>

    <div style="text-align: left;">
      <p class="pricing-details-text">
        <i class="fas fa-check-circle" style="color: var(--primary-color);"></i>
        Send job offers to <b>{{ postJobs }}</b> job boards
      </p>
      <p class="pricing-details-text">
        <i class="fas fa-check-circle" style="color: var(--primary-color);"></i>
        Single payment
      </p>
      <p class="pricing-details-text">
        <i class="fas fa-check-circle" style="color: var(--primary-color);"></i>
        All features
      </p>
      <p class="pricing-details-text">
        <i class="fas fa-check-circle" style="color: var(--primary-color);"></i>
        Access to your dashboard
      </p>
    </div>

    <!-- <div style="position: absolute;"> -->
    <button @click="buy(id)" class="primary-button" style="width: 100%;" type="button">
      Send {{ postJobs }} Jobs for
      {{ parsedPrice(unitAmount, currency) }}
    </button>
    <!-- </div> -->
  </div>
</template>

<script>
import firebase from "@/firebase";
import utils from "@/utils";

export default {
  props: {
    mostPurchased: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: false,
      default: "",
    },
    id: {
      type: Number,
      required: true,
    },
    unitAmount: {
      type: Number,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
    postJobs: {
      type: Number,
      required: true,
    },
    mostPurchasedText: {
      type: String,
      default: "Most purchased 🔥",
    },
    storeId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      interval: "month",
      loading: false,
    };
  },

  methods: {
    async buy(id) {
      if (firebase.auth.currentUser == null) {
        this.$router.push({ path: "/sign-up" });
        return;
      }

      const Paddle = window.Paddle;
      const passthrough = {
        userId: firebase.auth.currentUser.uid,
        storeId: this.storeId,
      };
      try {
        Paddle.Checkout.open({
          product: id,
          email: firebase.auth.currentUser.email,
          passthrough,
          successCallback: async () => {
            Paddle.Spinner.show();
            await utils.sleep(5000);
            Paddle.Spinner.hide();

            firebase.analytics.logEvent("paddle-purchase-accepted", {
              product: id,
              email: firebase.auth.currentUser.email,
              passthrough,
            });

            this.$router.push({ path: "/dashboard" });
          },
          closeCallback: (e) => {
            alert("Failed to checkout");

            firebase.analytics.logEvent("paddle-purchase-failed", {
              requestData: {
                product: id,
                email: firebase.auth.currentUser.email,
                passthrough,
              },
              checkoutData: e,
            });
          },
        });
      } catch (e) {
        console.error("errors", e);
      }
    },

    parsedPrice(p, c) {
      return c + Number(p / 100).toFixed(0);
    },
  },
};
</script>

<style></style>
